module.exports = __webpack_public_path__ + "static/img/dishini.31b672fd.jpg";